import React from 'react'
import { usePathname } from 'next/navigation'
import { HeaderLink } from './HeaderLink'

export const HeaderLinksListItems: React.FC = () => {
  const pathname = usePathname()
  const links = [
    { href: '/my-account', label: 'Home' },
    { href: '/help', label: 'Help' },
  ]
  return (
    <>
      {links.map((link) => (
        <li key={link.href}>
          <HeaderLink href={link.href} current={pathname === link.href} label={link.label} />
        </li>
      ))}
    </>
  )
}
